import React from "react";

import styles from "./Checkbox.module.scss";

const Checkbox = ({ text, register, label }) => {
  return (
    <label className={styles.Checkbox}>
      <input type="checkbox" className={styles.Input} value={text} {...register(label)} />

      <span className={styles.StyledCheckbox}>{text}</span>
    </label>
  );
};

export default Checkbox;
